"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Citroen = function Citroen(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M18.585 10.538C17.36 9.489 13.725 6.504 12 6.504c-1.726 0-5.36 2.983-6.583 4.033-.008-.248-.015-.399-.015-.62 0 0-.03-.364.293-.729 2.654-2.405 5.437-3.582 5.523-3.618.83-.35.783-.284.782-1.692 0 0 .037-.002.06 0 1.17.106 4.311 3.155 6.17 5.217.004.003.368.424.368.868 0 .208-.007.413-.013.575m-.05-1.72c-.198-.22-4.85-5.356-6.535-5.356-1.684 0-6.337 5.136-6.534 5.355-.02.022-.474.54-.474 1.146 0 .471.031.946.032.95 0 .022.011.222.123.277a.13.13 0 00.057.013.24.24 0 00.138-.055c.05-.044 4.79-4.231 6.658-4.231 1.868 0 6.608 4.187 6.656 4.23a.244.244 0 00.14.056c.02 0 .04-.004.058-.013.11-.055.122-.255.123-.278 0-.003.031-.478.031-.949 0-.605-.454-1.124-.473-1.146m.056 6.61c-1.225-1.05-4.864-4.038-6.591-4.038-1.728 0-5.365 2.987-6.59 4.038-.007-.248-.014-.4-.014-.62 0 0-.03-.365.293-.73 2.657-2.408 5.442-3.586 5.528-3.622.83-.35.784-.285.783-1.694 0 0 .037-.002.06 0 1.17.106 4.315 3.159 6.177 5.222.003.004.367.425.367.87 0 .207-.006.413-.013.575m-.05-1.723c-.197-.219-4.855-5.36-6.541-5.36s-6.344 5.141-6.541 5.36c-.02.022-.474.542-.474 1.147 0 .472.031.947.032.951 0 .022.011.223.123.277a.128.128 0 00.058.014.242.242 0 00.137-.055c.05-.045 4.795-4.236 6.665-4.236s6.615 4.191 6.663 4.233a.246.246 0 00.14.058c.02 0 .04-.005.058-.014.11-.054.122-.255.123-.278 0-.003.031-.478.031-.95 0-.605-.454-1.125-.474-1.147m-3.35 6.492h-.001a6.466 6.466 0 01-.376 0c-.415 0-.863-.315-.863-.824 0-.504.439-.806.86-.806.006 0 .211-.01.38 0 .425 0 .864.302.864.806 0 .509-.448.824-.863.824m.404-1.948c-.59-.013-1.19 0-1.194 0-.72 0-1.307.503-1.307 1.12 0 .628.586 1.138 1.307 1.138.005 0 .604.012 1.195 0 .722 0 1.309-.51 1.309-1.137 0-.612-.575-1.104-1.31-1.12m7.67 2.228H24v-1.076c0-.628-.56-1.121-1.274-1.121h-1.858c-.03 0-.102.007-.102.082v2.032c0 .054.04.083.079.083h.777v-1.7a.11.11 0 01.11-.114h.857c.236 0 .587.217.587.683v1.046s.002.085.09.085M7.757 18.717h1.147v-.35c0-.049-.035-.086-.082-.086H5.627a.083.083 0 00-.083.085v.35l.764.001c.286 0 .479.247.479.478v1.2c0 .04.035.083.084.083h.775V18.83c0-.062.05-.112.112-.112m-3.532 1.678c0 .049.044.083.084.083h.044l-.006.006c.022-.006.097-.006.357-.006h.38v-2.114a.084.084 0 00-.083-.084H4.31a.085.085 0 00-.084.084zm5.994-1.085v-.44c0-.12.085-.203.206-.203h1.14c.173 0 .32.146.32.32a.323.323 0 01-.323.323zm1.668 1.169h.852c-.013-.528-.56-.747-.623-.77l-.01-.005v-.03l.011-.002c.366-.082.62-.363.62-.684 0-.34-.33-.708-.866-.708H9.811a.443.443 0 00-.446.45v1.664a.08.08 0 00.082.083l.774.001-.001-.78h.73c.65 0 .918.473.938.78zm-8.965-1.46h.835c-.181-.46-.682-.776-1.257-.787l-.256-.005a10.959 10.959 0 00-.938.005c-.41.021-.67.115-.923.338a1.07 1.07 0 00-.384.807c0 .628.556 1.122 1.292 1.147.505.018.56.019 1.222 0 .613-.02 1.053-.3 1.243-.786h-.834a.078.078 0 00-.072.041.868.868 0 01-.754.425c-.171.007-.378 0-.378 0-.424 0-.863-.308-.863-.823v-.005c.003-.512.44-.818.865-.819.048-.002.219-.007.376 0 .309 0 .606.165.756.42.005.01.026.041.07.041m17.384 1.065h-2.02c-.068 0-.116-.045-.116-.11v-.419h1.75v-.385h-1.75l-.001-.383c0-.002-.001-.043.03-.075.023-.024.057-.036.1-.036h2.006v-.308a.081.081 0 00-.022-.061c-.028-.027-.073-.025-.076-.025h-2.81c-.009 0-.085.002-.085.086v1.664c0 .22.168.447.45.447h2.46c.02 0 .041-.009.058-.024a.08.08 0 00.026-.058v-.313m-.628-2.597a.55.55 0 00-.298-.077.558.558 0 00-.297.077c-.079.049-.141.115-.234.115-.093 0-.149-.066-.232-.115a.57.57 0 00-.297-.077.553.553 0 00-.298.077c-.082.05-.123.111-.123.182 0 .072.041.133.123.183.083.051.182.076.298.076a.563.563 0 00.29-.07c.075-.045.155-.12.239-.12.084 0 .16.067.234.114a.57.57 0 00.297.076c.12 0 .22-.025.3-.076.08-.05.12-.111.12-.183 0-.07-.04-.132-.122-.182Z"
  }));
};

Citroen.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Citroen.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Citroen;
exports.default = _default;